import {
  BehaviorAuthorizationType,
  useHasBehaviorAuthorization,
} from './useHasBehaviorAuthorization';

/** Shared estate UI policies; the server also checks access to each household. */
export function useEstatePermissions() {
  const canEditEstateWaterfall = useHasBehaviorAuthorization(
    BehaviorAuthorizationType.CAN_CREATE_UPDATE_DELETE_ESTATE_WATERFALLS,
    { returnFalseOnMissingUser: true }
  );
  const canPresentEstateWaterfall = useHasBehaviorAuthorization(
    BehaviorAuthorizationType.CAN_PRESENT_ESTATE_WATERFALLS,
    { returnFalseOnMissingUser: true }
  );
  const canEditDispositiveProvisions = useHasBehaviorAuthorization(
    BehaviorAuthorizationType.CAN_EDIT_DISPOSITIVE_PROVISIONS,
    { returnFalseOnMissingUser: true }
  );

  return {
    canEditEstateWaterfall,
    canPresentEstateWaterfall,
    canEditDispositiveProvisions,
  };
}
